document.addEventListener('alpine:init', () => {
  Alpine.data('newsDetail', () => ({
    showList: false,
    toggleList() {
      this.showList = !this.showList;
    },
    isShowList() {
      return this.showList === true;
    },
    }));
});
